
  (function () {
    var container = document.querySelector('[data-gift-options]');
    if (!container) return;

    var radios = container.querySelectorAll('input[name="properties[ギフトオプション]"]');

    var purposeBlock = container.querySelector('[data-gift-purpose]');
    var purposeSelect = container.querySelector('[data-purpose-select]');
    var purposeOtherWrap = container.querySelector('[data-purpose-other]');
    var purposeOtherInput = purposeOtherWrap
      ? purposeOtherWrap.querySelector('input[name="properties[用途（その他）]"]')
      : null;

    var tagBlock = container.querySelector('[data-gift-tag]');
    var messageBlock = container.querySelector('[data-gift-message]');

    // 名札
    // ▼ data-tag-text があれば優先して拾う（無くても既存nameで拾える）
    var tagText = container.querySelector('[data-tag-text]')
      || container.querySelector('textarea[name="properties[名札の内容]"]');

    var tagPurposeSelect = container.querySelector('[data-tag-purpose]');
    var tagPurposeOtherWrap = container.querySelector('[data-tag-purpose-other]');
    var tagPurposeOtherInput = tagPurposeOtherWrap
      ? tagPurposeOtherWrap.querySelector('input[name="properties[名札の用途（その他）]"]')
      : null;

    // メッセージカード
    // ▼ data-message-text があれば優先して拾う（無くても既存nameで拾える）
    var messageText = container.querySelector('[data-message-text]')
      || container.querySelector('textarea[name="properties[メッセージカードの内容]"]');

    var messagePurposeSelect = container.querySelector('[data-message-purpose]');
    var messagePurposeOtherWrap = container.querySelector('[data-message-purpose-other]');
    var messagePurposeOtherInput = messagePurposeOtherWrap
      ? messagePurposeOtherWrap.querySelector('input[name="properties[メッセージカードの用途（その他）]"]')
      : null;

    function updateSelectOtherUI(selectEl, otherWrapEl, otherInputEl) {
      if (!selectEl || !otherWrapEl) return;

      var isOther = selectEl.value === 'その他';
      otherWrapEl.hidden = !isOther;

      if (!isOther && otherInputEl) {
        otherInputEl.value = '';
        otherInputEl.required = false; // 念のため
      }
    }

    /* =========================================================
      ▼▼▼ 名札用途ごとの placeholder 切替
    ========================================================= */
    var tagCommonPrefix = '一般的によく利用される書き方例文\n\n';
    var tagPlaceholders = {
      '': '',

      '祝 御祝':
        '祝 御祝\n' +
        '株式会社スタイルラボ（自社の所属）\n' +
        '代表取締役 すたいるらぼ太郎（自分の役職・名前）',

      '祝 御開店':
        '祝 御開店\n' +
        '株式会社スタイルラボ（自社の所属）\n' +
        '代表取締役 すたいるらぼ太郎（自分の役職・名前）',

      '祝 御開業':
        '祝 御開業\n' +
        '株式会社スタイルラボ（自社の所属）\n' +
        '代表取締役 すたいるらぼ太郎（自分の役職・名前）',

      '祝 御開院':
        '祝 御開院\n' +
        '株式会社スタイルラボ（自社の所属）\n' +
        '代表取締役 すたいるらぼ太郎（自分の役職・名前）',

      '祝 御移転':
        '祝 御移転\n' +
        '株式会社スタイルラボ（自社の所属）\n' +
        '代表取締役 すたいるらぼ太郎（自分の役職・名前）',

      '祝 御竣工':
        '祝 御竣工\n' +
        '株式会社スタイルラボ（自社の所属）\n' +
        '代表取締役 すたいるらぼ太郎（自分の役職・名前）',

      '祝 御就任':
        '祝 御就任\n' +
        '株式会社スタイルラボ（自社の所属）\n' +
        '代表取締役 すたいるらぼ太郎（自分の役職・名前）',

      'その他':
        '用途に合わせてご記入ください。\n' +
        '（例）\n' +
        '会社名\n' +
        '役職 氏名'
    };

    function updateTagTextPlaceholder() {
      if (!tagPurposeSelect || !tagText) return;

      var v = tagPurposeSelect.value || '';
      var ph = tagPlaceholders[v];

      if (typeof ph === 'undefined') {
        tagText.placeholder = '会社名、役職、氏名などをご記入ください。';
        return;
      }

      // ▼ その他以外は prefix を付ける
      if (v && v !== 'その他') {
        tagText.placeholder = tagCommonPrefix + ph;
      } else {
        tagText.placeholder = ph;
      }
    }

    /* =========================================================
      ▼▼▼ メッセージカード用途ごとの placeholder 切替
    ========================================================= */
    var messageCommonPrefix = '一般的によく利用される書き方例文\n\n';

    var messagePlaceholders = {
      '': '',

      '結婚・記念日':
        'ご結婚〇周年　おめでとうございます！\n' +
        '素敵なお二人、いつも羨ましいです。\n' +
        'これからもご夫婦の歴史に素晴らしい思い出を刻まれますように！',

      '卒業・入学':
        'ご卒業・ご入学おめでとうございます。\n' +
        'これからの新しいステージでのご活躍を心よりお祈りしております。',

      '開店・開業':
        'ご開店・ご開業おめでとうございます。\n' +
        '今後のご繁栄とご発展を心よりお祈り申し上げます。',

      '敬老・長寿祝い':
        'いつまでもお元気でお過ごしください。\n' +
        'これからも素敵な毎日をお過ごしになられますように。',

      '出産祝い':
        'ご出産おめでとうございます。\n' +
        '健やかなご成長とご家族の幸せを心よりお祈りしております。',

      '送別・退職':
        'これまで本当にお疲れさまでした。\n' +
        '新たな道でのご活躍を心よりお祈りしております。',

      'お供え・お悔やみ':
        '心よりお悔やみ申し上げます。\n' +
        'ご冥福をお祈りいたします。',

      'インテリア':
        '日々の暮らしの中で、\n' +
        'ささやかな癒しとなりますように。',

      'その他':
        '用途に合わせてご記入ください。'
    };

function updateMessageTextPlaceholder() {
  if (!messagePurposeSelect) return;

  // ▼表示中のtextareaを毎回拾い直す（Dawn等のDOM差し替え対策）
  var _messageText = container.querySelector('[data-message-text]')
    || container.querySelector('textarea[name="properties[メッセージカードの内容]"]');

  if (!_messageText) return;

  var v = messagePurposeSelect.value || '';
  var ph = messagePlaceholders[v];

  // 未選択の時に何も出したくないならこのままでOK（出したいなら文言を入れる）
  if (typeof ph === 'undefined') {
    _messageText.placeholder = 'ご自由にメッセージをご記入ください。';
    return;
  }

  if (v && v !== 'その他') {
    _messageText.placeholder = messageCommonPrefix + ph;
  } else {
    _messageText.placeholder = ph;
  }
}

    function clearPurposeFields() {
      if (purposeSelect) {
        purposeSelect.value = '';
        purposeSelect.required = false; // 必須解除
      }

      if (purposeOtherInput) {
        purposeOtherInput.value = '';
        purposeOtherInput.required = false;
      }

      if (purposeOtherWrap) {
        purposeOtherWrap.hidden = true;
      }
    }

    function clearTagFields() {
      if (tagText) tagText.value = '';
      if (tagPurposeSelect) tagPurposeSelect.value = '';
      if (tagPurposeOtherInput) tagPurposeOtherInput.value = '';
      if (tagPurposeOtherWrap) tagPurposeOtherWrap.hidden = true;

      if (tagText) tagText.placeholder = '';
    }

    function clearMessageFields() {
      if (messageText) messageText.value = '';
      if (messagePurposeSelect) messagePurposeSelect.value = '';
      if (messagePurposeOtherInput) messagePurposeOtherInput.value = '';
      if (messagePurposeOtherWrap) messagePurposeOtherWrap.hidden = true;

      if (messageText) messageText.placeholder = '';
    }

    function updateGiftUI() {
      var selected = container.querySelector('input[name="properties[ギフトオプション]"]:checked');
      if (!selected) return;

      var value = selected.value;

      if (value === 'オプションなし') {
        // 用途を表示
        if (purposeBlock) purposeBlock.hidden = false;
        updateSelectOtherUI(purposeSelect, purposeOtherWrap, purposeOtherInput);

        // 用途を必須にする（オプションなし時のみ）
        if (purposeSelect) purposeSelect.required = true;

        // 名札/メッセージは隠して値もクリア
        if (tagBlock) {
          tagBlock.hidden = true;
          clearTagFields();
        }
        if (messageBlock) {
          messageBlock.hidden = true;
          clearMessageFields();
        }

      } else if (value === '名札') {
        // 用途（オプションなし用）は隠してクリア
        if (purposeBlock) {
          purposeBlock.hidden = true;
          clearPurposeFields();
        }

        if (tagBlock) tagBlock.hidden = false;
        updateSelectOtherUI(tagPurposeSelect, tagPurposeOtherWrap, tagPurposeOtherInput);

        // 名札を表示した直後にも placeholder を反映
        updateTagTextPlaceholder();

        if (messageBlock) {
          messageBlock.hidden = true;
          clearMessageFields();
        }

      } else if (value === 'メッセージカード') {
        // 用途（オプションなし用）は隠してクリア
        if (purposeBlock) {
          purposeBlock.hidden = true;
          clearPurposeFields();
        }

        if (messageBlock) messageBlock.hidden = false;
        updateSelectOtherUI(messagePurposeSelect, messagePurposeOtherWrap, messagePurposeOtherInput);

        // メッセージカードを表示した直後にも placeholder を反映
        updateMessageTextPlaceholder();

        if (tagBlock) {
          tagBlock.hidden = true;
          clearTagFields();
        }

      } else {
        // 想定外の値でも安全に全非表示 + クリア
        if (purposeBlock) {
          purposeBlock.hidden = true;
          clearPurposeFields();
        }
        if (tagBlock) {
          tagBlock.hidden = true;
          clearTagFields();
        }
        if (messageBlock) {
          messageBlock.hidden = true;
          clearMessageFields();
        }
      }
    }

    // ギフトオプション切替
    radios.forEach(function (radio) {
      radio.addEventListener('change', updateGiftUI);
    });

    // オプションなし「用途」=その他 切替
    if (purposeSelect) {
      purposeSelect.addEventListener('change', function () {
        updateSelectOtherUI(purposeSelect, purposeOtherWrap, purposeOtherInput);

        // ここで用途（その他）を必須にしたい場合は以下をONに
        if (purposeOtherInput) {
          purposeOtherInput.required = (purposeSelect.value === 'その他');
        }
      });
    }

    // 名札「その他」切替
    if (tagPurposeSelect) {
      tagPurposeSelect.addEventListener('change', function () {
        updateSelectOtherUI(tagPurposeSelect, tagPurposeOtherWrap, tagPurposeOtherInput);

        // placeholder更新
        updateTagTextPlaceholder();

        // 名札用途「その他」入力を必須にしたい場合（任意）
        if (tagPurposeOtherInput) {
          tagPurposeOtherInput.required = (tagPurposeSelect.value === 'その他');
        }
      });
    }

    // メッセージカード「その他」切替
    if (messagePurposeSelect) {
      messagePurposeSelect.addEventListener('change', function () {
        updateSelectOtherUI(messagePurposeSelect, messagePurposeOtherWrap, messagePurposeOtherInput);

        // placeholder更新
        updateMessageTextPlaceholder();

        // メッセージカード用途「その他」入力を必須にしたい場合（任意）
        if (messagePurposeOtherInput) {
          messagePurposeOtherInput.required = (messagePurposeSelect.value === 'その他');
        }
      });
    }


function validatePurposeWhenNoOption() {
  // 「オプションなし」選択中のみ必須
  var selected = container.querySelector('input[name="properties[ギフトオプション]"]:checked');
  if (!selected) return true;

  if (selected.value !== 'オプションなし') return true;

  // 用途 select の必須チェック
  if (!purposeSelect) return true;

  // 未選択（空）ならNG
  if (!purposeSelect.value) {
    // 見た目の合図（任意）
    purposeSelect.focus();

    // ブラウザ標準のバリデーションUIを出したい場合
    // requiredを付けて reportValidity を呼ぶ
    purposeSelect.required = true;
    if (typeof purposeSelect.reportValidity === 'function') {
      purposeSelect.reportValidity();
    } else {
      alert('「用途」を選択してください。');
    }
    return false;
  }

  // 「その他」ならテキストも必須にしたい場合（任意）
  if (purposeSelect.value === 'その他' && purposeOtherInput) {
    if (!purposeOtherInput.value.trim()) {
      purposeOtherInput.required = true;
      purposeOtherInput.focus();
      if (typeof purposeOtherInput.reportValidity === 'function') {
        purposeOtherInput.reportValidity();
      } else {
        alert('「用途（その他）」を入力してください。');
      }
      return false;
    }
  }

  return true;
}

// ------------------------------------------------------
// ✅ Dawnでも確実に拾える：form属性から実際のformを特定
// ------------------------------------------------------
var formId =
  (radios && radios[0] && radios[0].getAttribute('form')) ||
  (purposeSelect && purposeSelect.getAttribute('form')) ||
  (container.querySelector('[form]') && container.querySelector('[form]').getAttribute('form'));

var productForm = formId ? document.getElementById(formId) : null;

// それでも見つからない場合は近いformを拾う（保険）
if (!productForm) {
  productForm = container.closest('form');
}

// ------------------------------------------------------
// ✅ submitを止める（capture=trueはそのまま）
// ------------------------------------------------------
if (productForm) {
  productForm.addEventListener(
    'submit',
    function (e) {
      if (!validatePurposeWhenNoOption()) {
        e.preventDefault();
        e.stopPropagation();
        return false;
      }
    },
    true
  );
} else {
  // formが取れてないときの保険（デバッグ用に一時的に）
  // console.warn('[gift-options] product form not found. formId=', formId);
}


    // 初期状態反映
    updateGiftUI();
  })();



//ボタンのDisable制御
document.addEventListener('DOMContentLoaded', function () {
  var container = document.querySelector('[data-gift-options]');
  if (!container) return;

  // gift-options が属している form を特定（form="" で紐付けられていても拾える）
  function getProductForm() {
    // 1) gift-options 内に form があればそれ
    var f = container.closest('form');
    if (f) return f;

    // 2) gift-options 内の input が form="xxx" を持っていれば、そのIDの form を拾う
    var anyWithForm = container.querySelector('[form]');
    if (anyWithForm) {
      var formId = anyWithForm.getAttribute('form');
      if (formId) {
        var byId = document.getElementById(formId);
        if (byId) return byId;
      }
    }
    return null;
  }

  function getSubmitButton(formEl) {
    if (!formEl) return null;
    // Dawn標準：button[name="add"] が submit
    return formEl.querySelector('button[name="add"], button[type="submit"][name="add"]');
  }

  function getSelectedGift() {
    return container.querySelector('input[name="properties[ギフトオプション]"]:checked');
  }

  function getPurposeSelect() {
    return container.querySelector('[data-purpose-select], select[name="properties[用途]"]');
  }

function updateSubmitButtonState() {
  var formEl = getProductForm();
  var btn = getSubmitButton(formEl);
  if (!btn) return;

  var selectedGift = getSelectedGift();
  var purposeSelect = getPurposeSelect();

  var shouldDisable = false;

  // 「オプションなし」かつ「用途未選択」だけ無効
  if (selectedGift && selectedGift.value === 'オプションなし') {
    if (purposeSelect && !purposeSelect.value) {
      shouldDisable = true;
    }
  }

  // disabled 制御
  btn.disabled = shouldDisable;
  btn.classList.toggle('is-disabled', shouldDisable);

  // ▼▼▼ 注意文の制御 ▼▼▼
  var note = formEl.querySelector('.product-form__submit-note');

  // 無ければ作る（1回だけ）
  if (!note) {
    note = document.createElement('div');
    note.className = 'product-form__submit-note';
    note.textContent = '※用途を選択してください';
    note.hidden = true;

    // ボタン直下に入れる
    btn.parentNode.insertBefore(note, btn.nextSibling);
  }

  // 表示・非表示
  note.hidden = !shouldDisable;
}

  // 監視したいイベント（ギフトラジオ、用途select）
  container.addEventListener('change', function (e) {
    var t = e.target;
    if (
      t.matches('input[name="properties[ギフトオプション]"]') ||
      t.matches('[data-purpose-select]') ||
      t.matches('select[name="properties[用途]"]')
    ) {
      updateSubmitButtonState();
    }
  });

  // DawnのDOM差し替え対策：少し遅らせてもう一回
  updateSubmitButtonState();
  setTimeout(updateSubmitButtonState, 200);
  setTimeout(updateSubmitButtonState, 800);
});
